<template>
  <div class="examine-card">
        <img :src="examine.img" class="ec-img"/>
        <div class="ec-title">{{examine.title}}</div>
        <div class="ec-text">{{examine.textTop}}</div>
        <div class="ec-text ec-textBottom">{{examine.textBottom}}</div>
        <div v-if="examine.active==='2'" class="ec-bottom">
            <div class="ec-bottom-text" @click="updataExamine(examine.active)">
                重新提交
            </div>
        </div>
        <div v-if="examine.active==='3'" class="ec-bottom">
            <div class="ec-bottom-text" @click="updataExamine(examine.active)">
                联系客服
            </div>
        </div>
     </div>
</template>

<script>
// 信息审核
import { handleBuryPoint } from "@/utils/tool.js";
export default {
    name:"ExamineCard",
    props:{
        examine:{
            type:Object,
            default: ()=>{
                return {}
            }
        }
    },
    data(){
        return{
            
        }
    },
    methods:{
        // 重新提交
        updataExamine(val){
            this.$emit('updataExamine',val)
        }
    }
}
</script>

<style lang='less' scoped>
.examine-card { 
   margin-top:16px;
   padding-bottom:40px;
//    height: 393px;
   background: #FFFFFF;
   border-radius: 14px;
   display: flex;
   flex-direction: column;
   align-items: center;
   .ec-img{
       margin-top:62px;
       width: 124px;
       height: 124px;
   }
   .ec-title{
       margin-top:4px;
       font-family: PingFangSC-Medium;
       font-size: 42px;
       color: rgba(0,0,0,0.90);
       letter-spacing: 0;
   }
   .ec-text{
       margin-top:4px;
       font-family: PingFangSC-Regular;
        font-size: 28px;
        color: rgba(0,0,0,0.60);
        letter-spacing: 0;
        text-align: center;
        line-height: 39px;
   }
   .ec-textBottom{
       width: 508px;
       margin-bottom:22px;
   }
   .ec-bottom{
       width: 100%;
       display: flex;
   }
   .ec-bottom-text{
       flex:1;
       font-family: PingFangSC-Regular;
       font-size: 32px;
       color: #FFFFFF;
       margin-top:18px;
       margin-left:24px;
       margin-right:24px;
       height: 100px;
       background-image: linear-gradient(270deg, #27A0FF 0%, #176AF0 100%);
       border-radius: 8px;
       display: flex;
       justify-content: center;
       align-items: center;
   }

}
</style>
